import * as React from 'react';
export const wizardSvg = React.forwardRef(function wizardSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.977 16.34c1.774-.94 3.523.313 3.792.626 1.5 1.554.797 2.85 1.57 2.85s-.01-1.296 1.776-2.928c.246-.225 1.895-1.37 3.55-.627 2.66 1.409 5.072 2.871 5.428 3.078.423.247.106.855-.331.741-.548-.142-4.414-1.21-6.066-1.627-1.089-.274-1.472.453-1.173 1.332.3.879 1.913 4.875 2.227 5.625.231.572-.423.811-.747.375-.007-.009-2.082-2.696-3.093-3.844-1.346-1.527-1.993-1.135-2.85 0l-5.109 7.352c-.325.449-.958.108-.74-.387 0 0 3.556-7.976 4.024-9.16.414-1.045-.516-1.423-1.088-1.293-3.912.89-6.56 1.626-6.597 1.636-.527.137-.758-.517-.317-.75.025-.013 1.937-1.015 5.744-2.999ZM22.568 2.215c.32-.488.972-.056.764.413-.009.02-3.602 8.162-4.076 9.372-.42 1.07.536 1.452 1.103 1.322 3.99-.916 6.427-1.502 6.427-1.502.49-.135.752.487.305.725-.014.008-1.681.905-5.546 2.939-1.798.96-3.569-.32-3.84-.64-1.544-1.6-.794-2.918-1.615-2.918-.82 0 0 1.318-1.777 2.997-.247.234-1.92 1.402-3.596.64-2.696-1.441-5.447-3.085-5.808-3.297-.45-.265-.142-.887.357-.733.458.141 4.833 1.317 6.421 1.814 1.188.305 1.5-.488 1.198-1.388-.303-.899-2.082-5.155-2.386-5.87-.219-.537.416-.843.748-.42 0 0 2.228 2.932 3.274 4.083 1.394 1.536 2.066 1.152 2.885 0l5.162-7.537Z',
      fill: '#345CCC',
    }),
  );
});
wizardSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var wizard = {
  category: 'brand',
  colorable: false,
  name: 'wizard',
  svg: wizardSvg,
};
